import { setBotWaitLoaderWithShimmer } from "../../../state/actions/loader";
import store from "../../../state/configureStore";
import { uuidGenerator } from "../../../utils/general";
import { socketSendMessageEvent } from "../../socket/socketEvents";
import { getDataFromLFStorage } from "../../storage/LFStorage";
import { getAuthData, isUserOnline } from "../../storage/LocalStorage";
import { botContext } from "../initializeBotContext";
import { MessageTypeConstants } from "../Message";




export const processSendMessage = (sendMessageObj) => {
  if (isUserOnline()) {
    console.log(`%c Message send by webapp to bot >> ${sendMessageObj.messageType} >>`, "color: green;", sendMessageObj);

    const botParamsRaw = localStorage.getItem("botParams");
    const botParams = botParamsRaw ? JSON.parse(botParamsRaw) : null;

    const userDetail = getAuthData();
    const userData = userDetail.user || {}

    const userId = userData.userId || ""
    const messageId = uuidGenerator();

    const {
      message,
      completed,
      options,
      messageType = MessageTypeConstants.MESSAGE_TYPE_STRING,
    } = sendMessageObj;

    const processSendMessageObj = {
      messageType: messageType,
      message,
      options: options || null,
      createdBy: userId,
      createdOn: Date.now(),
      completed: completed,
      messageId: messageId,
      self: true,
    };

    let conversation = {
      conversationId: botParams.conversationId,
      bot: botParams.botId,
    }
    let parametersData = {
      messageType: messageType,
      message: processSendMessageObj.message
    }
    socketSendMessageEvent(parametersData, conversation);
  }
  else {
    store.dispatch(setBotWaitLoaderWithShimmer(false))
  }
};


export const sendMessageToBotContext = async (message) => {
  let prevMessages = botContext.conversationContext
    ? await getDataFromLFStorage(
      botContext.conversationContext.conversationId
    )
    : [];

  const data = parseInputMessage(message);
  botContext.botContent.next(
    data,
    botContext.botState,
    prevMessages,
    botContext
  );
};


const parseInputMessage = (data) => {
  const Message = botContext.getCapability("Message");
  const MessageTypeConstants = botContext.getCapability("MessageTypeConstants");
  let message = new Message({ uuid: data.messageId });
  let messageType = data.messageType;

  if (messageType === MessageTypeConstants.MESSAGE_TYPE_FORM2) {
    message.form2Message(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE) {
    message.formResponseMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE) {
    message.tableResponseMessage(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_SLIDER_RESPONSE
  ) {
    message.sliderResponseMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_FORM_CANCEL) {
    message.formCancelMessage(data.message);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_BUTTON_RESPONSE
  ) {
    message.buttonResponseMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_IMAGE) {
    message.imageMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_AUDIO) {
    message.audioMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEO) {
    message.videoMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEOPLAYER) {
    message.videoPlayer(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEOPLAYER_RESPONSE) {
    message.videoPlayerResponse(data.message, data?.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_SLIDER_CANCEL) {
    message.sliderCancelMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_PDF) {
    message.pdfMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_TEXT) {
    message.textFileMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_OTHER_FILE) {
    message.otherFileMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CSV) {
    message.csvMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_JAVASCRIPT) {
    message.jsMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_HTML) {
    message.htmlMessage(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_STRIPE_RESPONSE
  ) {
    message.stripeResponseMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_MAP_RESPONSE) {
    message.mapResponseMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CONTACT_CARD) {
    if (message.contactCard) {
      message.contactCard(data.message);
    } else {
      message.contactCardMessage(data.message);
    }
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_TRACKING_VIEW_RESPONSE
  ) {
    message.trackingViewResponseMessage(data.message);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_CONTAINER_RESPONSE
  ) {
    message.containerResponse(data.message);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_SEARCH_BOX_RESPONSE
  ) {
    message.searchBoxResponseMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEO_CALL) {
    message.videoCallMessage(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEO_CALL_RESPONSE
  ) {
    message.videoResponseMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_MENU_RESPONSE) {
    message.menuResponse(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_SOUND) {
    message.soundResponse(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_FLOORPLAN) {
    message.floorplan(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_FLOORPLAN_RESPONSE
  ) {
    message.floorplanResponse(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_GEOFENCE) {
    message.geofenceMessage(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_GEOFENCE_RESPONSE
  ) {
    message.geofenceResponse(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CALENDAR) {
    message.calendarMessage(data.message, data.options);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CARD_RESPONSE) {
    message.cardResponseMessage(data.message, data.options);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST
  ) {
    message.authorizationRequest(data.message);
  } else if (
    messageType ===
    MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST_RESPONSE
  ) {
    message.authorizationRequestResponse(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_HTML_RESPONSE) {
    message.htmlResponseMessage(data.message);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_TIMELINE_RESPONSE
  ) {
    message.timelinesResponseMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_SURVEY) {
    message.surveyMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CHAT) {
    message.chatMessage(data.message);
  }
  else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CHAT_RESPONSE) {
    message.chatResponseMessage(data.message);
  } else if (messageType === MessageTypeConstants.MESSAGE_TYPE_DASHBOARD) {
    message.dashboardMessage(data.message);
  } else if (
    messageType === MessageTypeConstants.MESSAGE_TYPE_SURVEY_RESPONSE
  ) {
    message.surveyResponseMessage(data.message);
  } else {
    message.stringMessage(data.message);
  }
  message.setCreatedBy(botContext.userDetails.userId);
  return message;
};